import { render, staticRenderFns } from "./WaybillUploadView.vue?vue&type=template&id=bcdc74fe&"
import script from "./WaybillUploadView.vue?vue&type=script&lang=js&"
export * from "./WaybillUploadView.vue?vue&type=script&lang=js&"
import style0 from "./WaybillUploadView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports